import { WidgetApiService } from "./widgetApiService";
import { FilesKeys, DocumentStore } from "../../stores/documentStore";
import { PolicyStore } from "../../stores/policyStore";


export interface DocumentService {
  downloadPdf: (fileKey: FilesKeys) => Promise<any>;
}

export class DefaultDocumentService {

  constructor(private widgetApiService: WidgetApiService, private documentStore: DocumentStore, private policyStore: PolicyStore) { }

  public async downloadPdf(fileKey: FilesKeys): Promise<any> {
    const policyNumber = this.policyStore.policyResponse.policyNumber;

    if (fileKey === FilesKeys.policy) {
      if (policyNumber) {
        return this.policyPdfRequest().then((resp) => {
          if (!this.documentStore.getFileRequestStatus(FilesKeys.policy).isError) {
            this.documentStore.savePdf(FilesKeys.policy, resp, "Polisa " + policyNumber + ".pdf");
          }
        });
      }
    } else if (fileKey === FilesKeys.paymentForm) {
      if (policyNumber) {
        return this.paymentFormRequest().then((resp) => {
          if (!this.documentStore.getFileRequestStatus(FilesKeys.paymentForm).isError) {
            this.documentStore.savePdf(FilesKeys.paymentForm, resp, "Druk płatności " + policyNumber + ".pdf");
          }
        });
      }
    } else {
      return this.pdfRequest(fileKey).then((resp) => {
        if (!this.documentStore.getFileRequestStatus(fileKey).isError) {
          this.documentStore.savePdf(fileKey, resp);
        }
      });
    }
  }

  private async pdfRequest(fileKey: FilesKeys): Promise<any> {
    const fileName = this.documentStore.files.get(fileKey)?.fileName;

    if (!fileName) {
      return Promise.reject();
    }

    return this.documentStore.getFileRequestStatus(fileKey).handleRequest(
      () => this.widgetApiService.pdf(fileName)
    );
  }

  private async policyPdfRequest(): Promise<any> {
    return this.documentStore.getFileRequestStatus(FilesKeys.policy).handleRequest(
      () => this.widgetApiService.policyPdf({
        token: this.policyStore.policyResponse.pdfToken
      })
    );
  }

  private async paymentFormRequest(): Promise<any> {
    return this.documentStore.getFileRequestStatus(FilesKeys.paymentForm).handleRequest(
      () => this.widgetApiService.paymentFormPdf({
        token: this.policyStore.policyResponse.pdfToken
      })
    );
  }

}
